import { CommitteeMemberType } from 'api/committees/committees.types';
import { AssignedQualificationType } from '../api/courses/courses.types';
import { ResponseCode } from '../helpers/constants';
import {
    DisciplineGradeType,
    EducationType,
    DocumentType,
    TrainingType,
    DisciplineType,
    ExtendedDocumentType,
    RecipiencyDocumentsType,
    RoleType
} from 'api/api';
import { StaticDocument } from 'api/documents/documents.types';

export const messages: Partial<
    Record<ResponseCode | 'AssignAlreadyPaid', React.ReactNode>
> = {
    Error: 'Произошла ошибка, повторите попытку позже',
    Ok: 'Успешно!',
    AuthException: 'Неверный логин или пароль',
    Unauthorized: 'Вы не авторизованы',
    Invalid: 'Проверьте правильность заполнения полей',
    EmailAlreadyUse: 'Этот E-mail уже используется другим пользователем',
    NotFoundDocumentTemplate: 'Шаблон документа не добавлен для организации',
    NotFoundFileEntry: 'Файл шаблона не найден',
    ServerError: (
        <>
            Произошла ошибка сервера.
            <br />
            Повторите попытку позже.
        </>
    ),
    RemoveCommitteeException: 'Эта комиссия используется в добавленных курсах',
    SendSmsError: 'Не удалось отправить SMS с кодом подтверждения',
    SendMailError: 'Не удалось отправить E-mail с кодом подтверждения',
    ManyRecoveryCodeRequests: 'Слишком много запросов на восстановление пароля',
    UserNotFound: 'Пользователь не найден',
    AssignNotPaid: 'Назначение не оплачено, недостаточно средств на балансе',
    AssignAlreadyPaid: 'Назначение уже оплачено',
    NotFoundRecipiencyDocuments: 'Документы для одного из назначений не найдены'
};

const trainingTypes: Record<TrainingType, string> = {
    ProfessionalTraining: 'ПО',
    AdvancedTraining: 'ПК',
    ProfessionalRetraining: 'ПП',
    Instruction: 'Инструктаж'
};

const qualificationTypes: Partial<Record<AssignedQualificationType, string>> = {
    MayBeAdmitted: 'Может быть допущен',
    Rank: 'Разряд'
};

const issuedDocuments: Partial<Record<DocumentType, string>> = {
    Diplom: 'Диплом',
    Certificate: 'Свидетельство',
    TicketB: 'Удостоверение Б',
    TicketM: 'Удостоверение М',
    CertificateEducation: 'Справка об обучении',
    Contract: 'Договор на обучение'
};

const staticDocuments: Record<StaticDocument, string> = {
    [StaticDocument.PaymentInvoice]: 'Счет на оплату',
    [StaticDocument.CertificateOfStudy]: 'Справка об обучении',
    [StaticDocument.TicketM]: 'Удостоверение М'
};

const committeeMemberType: Record<CommitteeMemberType, string> = {
    Chairman: 'Председатель',
    SubChairman: 'Заместитель председателя',
    MemberCommittee: 'Член комиссии'
};

const educationTypes: Record<EducationType, string> = {
    High: 'Высшее',
    MiddleCommon: 'Среднее общее',
    MiddleProfessional: 'Среднее профессиональное'
};

const extendedDocumentTypes: Record<ExtendedDocumentType, string> = {
    DiplomMain: 'Диплом основной',
    DiplomMainForPdf: 'Диплом основной для PDF',
    AppendixOne: 'Приложение к диплому 1',
    AppendixOneForPdf: 'Приложение к диплому 1 для PDF',
    AppendixTwo: 'Приложение к диплому 2',
    AppendixTwoForPdf: 'Приложение к диплому 2 для PDF',
    Certificate: 'Свидетельство',
    CertificateForPdf: 'Свидетельство для PDF',
    TicketB: 'Удостоверение Б',
    Contract: 'Договор',
    CertificateEducation: 'Справка об обучении',
    TicketMOne: 'Удостоверение М 1',
    TicketMTwo: 'Удостоверение М 2',
    TicketMThree: 'Удостоверение М 3'
};

const documentTypes: Record<DocumentType, string> = {
    Diplom: 'Диплом',
    Certificate: 'Свидетельство',
    TicketB: 'Удостоверение Б',
    Contract: 'Договор',
    CertificateEducation: 'Справка об обучении',
    TicketM: 'Удостоверение М'
};

export const gradeTypes: Record<DisciplineGradeType, string> = {
    Excelent: 'Отлично',
    Good: 'Хорошо',
    Accepted: 'Зачтено'
};

export const disciplineTypes: Record<DisciplineType, string> = {
    PO: 'ПО',
    PK: 'ПК',
    PP: 'ПП'
};

export const roleTitles: Partial<Record<RoleType, string>> = {
    [RoleType.Student]: 'Студент',
    [RoleType.Operator]: 'Оператор',
    [RoleType.HighOperator]: 'Администратор'
};

export const documentsAbbrs: Record<DocumentType, string> = {
    Diplom: 'Д',
    Certificate: 'Св',
    TicketM: 'УдМ',
    TicketB: 'УдБ',
    CertificateEducation: 'Сп',
    Contract: 'К'
};

export const recipiencyDocumentsType: Record<RecipiencyDocumentsType, string> =
    {
        Post: 'Почта',
        InEducationCenter: 'В учебном центре',
        NotNeeded: 'Не нужно'
    };

export default {
    trainingTypes,
    qualificationTypes,
    issuedDocuments,
    committeeMemberType,
    educationTypes,
    gradeTypes,
    staticDocuments,
    disciplineTypes,
    extendedDocumentTypes,
    documentTypes,
    roleTitles,
    documentsAbbrs,
    recipiencyDocumentsType
};
